import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth-guard';
import { roleGuard } from '../guards/role-guard';
import { Login } from '../features/login/login';
import { Signup } from '../features/signup/signup';
import { SetPassword } from '../features/set-password/set-password';
import { Dashboard } from '../features/dashboard/dashboard';
import { SchoolOnboarding } from '../features/school-onboarding/school-onboarding';
import { StepOne } from '../features/school-onboarding/subpages/step-one/step-one';
import { StepTwo } from '../features/school-onboarding/subpages/step-two/step-two';
import { StepThree } from '../features/school-onboarding/subpages/step-three/step-three';
import { AdminCreateSchool } from '../features/admin-create-school/admin-create-school';
import { UserMgt } from '../features/dashboard-subpages/user-mgt/user-mgt';
import { UserMgtOverview } from '../features/dashboard-subpages/user-mgt/subpages/user-mgt-overview/user-mgt-overview';
import { AdminWelcome } from '../features/admin-welcome/admin-welcome';
import { AcademicMgt } from '../features/dashboard-subpages/academic-mgt/academic-mgt';
import {
  AcademicOverview
} from '../features/dashboard-subpages/academic-mgt/subpages/academic-overview/academic-overview';
import { AcademicDetail } from '../features/dashboard-subpages/academic-mgt/subpages/level-detail/academic-detail';
import { DashboardOverview } from '../features/dashboard-subpages/dashboard-overview/dashboard-overview';
import { Class } from '../features/dashboard-subpages/class/class';
import { ClassOverview } from '../features/dashboard-subpages/class/subpages/class-overview/class-overview';
import { ClassDetail } from '../features/dashboard-subpages/class/subpages/class-detail/class-detail';
import { TeacherDetail } from '../features/dashboard-subpages/class/subpages/teacher-detail/teacher-detail';
import { Levels } from '../features/dashboard-subpages/academic-mgt/subpages/levels/levels';
import { AcademicYears } from '../features/dashboard-subpages/academic-mgt/subpages/academic-years/academic-years';
import { Terms } from '../features/dashboard-subpages/academic-mgt/subpages/terms/terms';
import { Subjects } from '../features/dashboard-subpages/academic-mgt/subpages/subjects/subjects';
import { TeacherOverview } from '../features/dashboard-subpages/class/subpages/teacher-overview/teacher-overview';
import { AuditLogs } from '../features/dashboard-subpages/audit-logs/audit-logs';
import { Students } from '../features/dashboard-subpages/academic-mgt/subpages/students/students';
import { StudentImport } from '../features/dashboard-subpages/academic-mgt/subpages/student-import/student-import';
import { SchoolProfile } from '../features/dashboard-subpages/school-profile/school-profile';
import { StudentDetail } from '../features/dashboard-subpages/academic-mgt/subpages/student-detail/student-detail';
import { StudentFees } from '../features/dashboard-subpages/student-fees/student-fees';
import { FeeOverview } from '../features/dashboard-subpages/student-fees/subpages/fee-overview/fee-overview';
import { Payments } from '../features/dashboard-subpages/student-fees/subpages/payments/payments';
import { FeeStructure } from '../features/dashboard-subpages/student-fees/subpages/fee-structure/fee-structure';
import { ClassAttendance } from '../features/dashboard-subpages/class/subpages/class-attendance/class-attendance';
import {
  AttendanceRegister
} from '../features/dashboard-subpages/class/subpages/attendance-register/attendance-register';
import { AttendanceHistory } from '../features/dashboard-subpages/class/subpages/attendance-history/attendance-history';
import { ClassAssessment } from '../features/dashboard-subpages/class/subpages/class-assessment/class-assessment';
import { LandingPage } from '../features/landing-page/landing-page';
import { GradeConfig } from '../features/dashboard-subpages/academic-mgt/subpages/grade-config/grade-config';

export const routes: Routes = [
  {
    path: '',
    component: LandingPage,
    title: 'Scientia ERP',
  },
  {
    path: 'login',
    component: Login,
    title: 'Scientia ERP | Login',
  },
  {
    path: 'signup',
    component: Signup,
    title: 'Scientia ERP | Sign up',
    canActivate: [roleGuard('SUPER_ADMIN')],
  },
  {
    path: 'set-password',
    component: SetPassword,
    title: 'Scientia ERP | Set Password',
    canActivate: [authGuard],
  },
  {
    path: 'admin-create-school',
    component: AdminCreateSchool,
    title: 'Scientia ERP | Add School',
    canActivate: [authGuard, roleGuard('SUPER_ADMIN')],
  },
  {
    path: 'school-onboarding',
    component: SchoolOnboarding,
    title: 'Scientia ERP | Onboard Your School',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'school-profile', pathMatch: 'full' },
      { path: 'school-profile', component: StepOne },
      { path: 'academic-year-configuration', component: StepTwo },
      { path: 'academic-term-configuration', component: StepThree },
    ],
  },
  {
    path: 'admin-welcome',
    component: AdminWelcome,
    title: 'Scientia ERP | Welcome Admin',
    canActivate: [authGuard, roleGuard('SUPER_ADMIN')],
  },
  {
    path: 'dashboard',
    component: Dashboard,
    title: 'Scientia ERP | Dashboard',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        pathMatch: 'full',
        component: DashboardOverview,
        title: 'Scientia ERP | Dashboard Overview',
      },
      {
        path: 'class',
        component: Class,
        title: 'Scientia ERP | The Class',
        canActivate: [authGuard, roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'TEACHER')],
        children: [
          { path: '', redirectTo: 'classes', pathMatch: 'full' },
          { path: 'classes', component: ClassOverview },
          { path: 'teachers', component: TeacherOverview },
          { path: 'class-details', component: ClassDetail },
          { path: 'teacher-details', component: TeacherDetail },
          {
            path: 'class-attendance',
            component: ClassAttendance,
            children: [
              { path: '', redirectTo: 'attendance-history', pathMatch: 'full' },
              { path: 'attendance-register', component: AttendanceRegister },
              { path: 'attendance-history', component: AttendanceHistory },
            ],
          },
          {
            path: 'class-assessment',
            component: ClassAssessment,
          },
        ],
      },
      {
        path: 'user-management',
        component: UserMgt,
        canActivate: [authGuard, roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN')],
        children: [
          { path: '', redirectTo: 'user-mgt-overview', pathMatch: 'full' },
          { path: 'user-mgt-overview', component: UserMgtOverview, title: 'Scientia ERP | Overview' },
        ],
      },
      {
        path: 'academic-management',
        component: AcademicMgt,
        children: [
          { path: '', redirectTo: 'levels', pathMatch: 'full' },
          {
            path: 'academic-mgt-overview',
            component: AcademicOverview,
            title: 'Scientia ERP | Academic Overview',
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'FINANCE_ADMIN', 'TEACHER')],
          },
          {
            path: 'levels',
            component: Levels,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'FINANCE_ADMIN', 'TEACHER')],
          },
          {
            path: 'academic-years',
            component: AcademicYears,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN')],
          },
          {
            path: 'terms',
            component: Terms,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN')],
          },
          {
            path: 'subjects',
            component: Subjects,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'TEACHER')],
          },
          {
            path: 'level-details',
            component: AcademicDetail,
            title: 'Scientia ERP | Level Details',
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'FINANCE_ADMIN', 'TEACHER')],
          },
          {
            path: 'students',
            component: Students,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'FINANCE_ADMIN', 'TEACHER')],
          },
          {
            path: 'student-import',
            component: StudentImport,
            title: 'Scientia ERP | Bulk Student Import',
            canActivate: [roleGuard('SCHOOL_ADMIN')],
          },
          {
            path: 'student-details',
            component: StudentDetail,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'FINANCE_ADMIN', 'TEACHER')],
          },
          {
            path: 'grade-configuration',
            component: GradeConfig,
            canActivate: [roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN')]
          },
        ],
      },
      {
        path: 'audit-logs',
        component: AuditLogs,
        title: 'Scientia ERP | Audit Logs',
        canActivate: [authGuard, roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN')],
      },
      {
        path: 'school-profile',
        component: SchoolProfile,
        title: 'Scientia ERP | School Profile',
        canActivate: [authGuard, roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN')],
      },
      {
        path: 'student-fees',
        component: StudentFees,
        title: 'Scientia ERP | Student Fees',
        canActivate: [authGuard, roleGuard('SUPER_ADMIN', 'SCHOOL_ADMIN', 'FINANCE_ADMIN')],
        children: [
          { path: '', redirectTo: 'fee-overview', pathMatch: 'full' },
          { path: 'fee-overview', component: FeeOverview },
          { path: 'payments', component: Payments },
          { path: 'fee-structure', component: FeeStructure },
        ],
      },
      {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full',
      },
    ],
  },
];
